import { UserRole } from "tm-shared/types";

export interface InfoTabPlanCapabilities {
    canSeePlan: boolean;
}

export const getInfoTabPlanCapabilities = (
    role: UserRole | null,
): InfoTabPlanCapabilities => ({
    canSeePlan:
        role === UserRole.Ta || role === UserRole.Sv || role === UserRole.Svm,
});
